import GroupDetails from "./groupDetails.container";

export default GroupDetails;
